export const getEsusParameters = (params?: string) => {
  if (params && params.endsWith('=')) {
    return new Map(
      atob(params)
        .split('&')
        .map((i) => [i.split('=')[0], i.split('=')[1]])
    )
  }
}
